export const GAI7RidersPropertyPath = [
  { isAppliedPath: `isHospitalAdmissionApplied`, details: `hospitalAdmissionDetails` },
  { isAppliedPath: `isHospitalConfinementApplied`, details: `hospitalConfinementDetails` },
  { isAppliedPath: `isIntensiveCareUnitConfinementApplied`, details: `intensiveCareUnitConfinementDetails` },
  { isAppliedPath: `isObjectiveSecondOpinionApplied`, details: `objectiveSecondOpinionDetails` },
  {
    isAppliedPath: `isStepDownIntensiveCareUnitConfinementApplied`,
    details: `stepDownIntensiveCareUnitConfinementDetails`,
  },
  { isAppliedPath: `isRehabilitationFacilityApplied`, details: `rehabilitationFacilityDetails` },

  { isAppliedPath: `isBrainInjuryDiagnosisApplied`, details: `brainInjuryDiagnosisDetails` },
  { isAppliedPath: `isBrokenToothApplied`, details: `brokenToothDetails` },
  { isAppliedPath: `isBurnApplied`, details: `burnDetails` },
  { isAppliedPath: `isBurnSkinGraftApplied`, details: `burnSkinGraftDetails` },
  { isAppliedPath: `isComaApplied`, details: `comaDetails` },
  { isAppliedPath: `isLacerationApplied`, details: `lacerationDetails` },
  { isAppliedPath: `isParalysisApplied`, details: `paralysisDetails` },
  { isAppliedPath: `isPunctureWoundApplied`, details: `punctureWoundDetails` },
  { isAppliedPath: `isGunshotWoundApplied`, details: `gunshotWoundDetails` },

  { isAppliedPath: `isFollowUpTreatmentApplied`, details: `followUpTreatmentDetails` },

  { isAppliedPath: `isAccidentPhysicianTreatmentApplied`, details: `ambulanceUrgentCareBenefit` },
  { isAppliedPath: `isAmbulanceAirApplied`, details: `ambulanceAirDetails` },
  { isAppliedPath: `isAmbulanceGroundOrWaterApplied`, details: `ambulanceGroundOrWaterDetails` },
  { isAppliedPath: `isUrgentCareApplied`, details: `urgentCareDetails` },
  { isAppliedPath: `isXRayApplied`, details: `xRayDetails` },

  { isAppliedPath: `isEmergencyRoomServicesApplied`, details: `emergencyRoomServicesDetails` },
  { isAppliedPath: `isMiscellaneousOutpatientSurgeryApplied`, details: `miscellaneousOutpatientSurgeryDetails` },
  { isAppliedPath: `isOpenAbdominalOrThoracicSurgeryApplied`, details: `openAbdominalOrThoracicSurgeryDetails` },
  { isAppliedPath: `isTendonLigamentRotatorCuffApplied`, details: `tendonLigamentRotatorCuffDetails` },
  { isAppliedPath: `isGeneralAnesthesiaApplied`, details: `generalAnesthesiaDetails` },
  { isAppliedPath: `isRupturedDiscApplied`, details: `rupturedDiscDetails` },
  { isAppliedPath: `isBloodPlasmaPlateletsApplied`, details: `bloodPlasmaPlateletsDetails` },
  { isAppliedPath: `isEyeInjuryApplied`, details: `eyeInjuryDetails` },
  { isAppliedPath: `isMajorDiagnosticExamApplied`, details: `majorDiagnosticExamDetails` },
  { isAppliedPath: `isPainManagementApplied`, details: `painManagementDetails` },
  {
    isAppliedPath: `isPainManagementCorticosteroidInjectionApplied`,
    details: `painManagementCorticosteroidInjectionBenefit`,
  },
  { isAppliedPath: `isCompanionNonLocalLodgingApplied`, details: `companionNonLocalLodgingDetails` },
  { isAppliedPath: `isMedicalEquipmentApplied`, details: `medicalEquipmentDetails` },
  { isAppliedPath: `isMedicalSuppliesApplied`, details: `medicalSuppliesDetails` },
  { isAppliedPath: `isMedicationApplied`, details: `medicationDetails` },
  { isAppliedPath: `isNonLocalTransportationApplied`, details: `nonLocalTransportationDetails` },
  {
    isAppliedPath: `isPostAccidentCommonCarrierTransportationApplied`,
    details: `postAccidentCommonCarrierTransportationDetails`,
  },
  { isAppliedPath: `isProsthesisApplied`, details: `prosthesisDetails` },
  { isAppliedPath: `isResidenceAutomobileModificationApplied`, details: `residenceAutomobileModificationDetails` },
  { isAppliedPath: `isTherapyApplied`, details: `therapyDetails` },
  { isAppliedPath: `isSpinalManipulationServicesApplied`, details: `spinalManipulationServicesDetails` },
  { isAppliedPath: `isAccidentalDeathApplied`, details: `accidentalDeathDetails` },
  { isAppliedPath: `isAccidentalDeathCommonCarrierApplied`, details: `accidentalDeathCommonCarrierDetails` },
  { isAppliedPath: `isAccidentalDismembermentApplied`, details: `accidentalDismembermentDetails` },
  { isAppliedPath: `isFunctionalLossApplied`, details: `functionalLossDetails` },
  { isAppliedPath: `isAutomobileAccidentalDeathApplied`, details: `automobileAccidentalDeathDetails` },
  { isAppliedPath: `isDislocationAndFractureRiderBenefitApplied`, details: `dislocationFractureRiderDetails` },
  { isAppliedPath: `isDislocationApplied`, details: `dislocationDetails` },
  { isAppliedPath: `isFractureApplied`, details: `fractureDetails` },
  { isAppliedPath: `isHealthScreeningServicesRiderApplied`, details: `healthScreeningServicesRiderDetails` },
  { isAppliedPath: `isOutpatientPhysicianTreatmentsApplied`, details: `outpatientPhysicianTreatmentsDetails` },
];
